<template>
    <div class="row">
        <div class="col-12">
            <button v-if="$UserSession.hasPriv('USERS_DOWNLOAD_LIST')"
                class="btn btn-outline-secondary ml-2 float-lg-right float-left" :title="$t('download')" @click="generateCSV()">
                <b-icon-download />
            </button>
            <button @click="$router.push('/settings/users/create')" type="button" class="btn btn-primary ml-auto float-right">{{ $t('create-user') }}</button>
            <h1 class="mb-4">{{$t('users')}}</h1>
            <Table
                :loading="loading"
                :submitting="submitting"
                :cols="[
                    { key: 'displayname', heading: $t('name'), size: 3, sortable: true, sortCol: 'LastName' },
                    { key: 'username', heading: $t('username'), size: 3, sortable: true, },
                    { key: 'email', heading: $t('email'), size: 4, sortable: true },
                    { key: 'status', heading: $t('status'), size: 2, sortable: true, cb: (user) => { return $t(user.status); }}
                ]"
                :data="users"
                breakpoint="md"
                :filters="{
                    ...filters,
                    page: filters.page,
                    page_size: filters.page_size,
                    total_count: total_count,
                }"
                :searchable="true"
                :scrollPaginate="true"
                @refresh="refresh"
                @toPage="toPage"
                @selectItem="user => $router.push(`/settings/users/update/${user.id}`)"
            >
                <!-- Table Header -->
                <template v-slot:header>
                    <div class="list-group-item align-items-center">

						<div class="form-inline">
							<!-- Filter by Role -->
							<select class="form-control w-auto mr-2" @input="refresh({ role: $event.target.value })">
								<option selected value="">{{  $t('all-roles') }}</option>
								<option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
							</select>
							<SelectInput
                                v-model="status"
								:options="['active', 'pending', 'suspended', 'closed']"
								:labelCb="(option) => { return $t(option); }"
								:label="$t('status')"
								:srOnly="true"
                                :nullable="true"
                                :nullLabel="$t('status')"
								@input="value => refresh({ status: value })"
								class="ml-2 mr-2 align-items-center"
							/>
                            <SelectInput
                                v-model="programme"
                                @input="value => refresh({ programme_id: value ? value.Id : '' })"
                                :label="$t('programme')"
                                :options="$config.getValue('programmes')"
                                optionLabel="Name"
                                :srOnly="true"
                                :nullable="true"
                                :nullLabel="$t('programme')"
                                class="ml-2 mr-2 align-items-center"
                            />
                            <select v-if="programme" class="form-control ml-2  align-items-center" @input="refresh({ year: $event.target.value })" :aria-label="$t('year')">
                                <option :value="null">{{ $t("year") }}</option>
                                <template>
                                    <option
                                        v-for="year in parseInt(programme.CourseLengthYears)"
                                        :key="year"
                                        :value="year"
                                        >{{ year }}
                                    </option>
                                    <option :value="parseInt(programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
                                </template>
                            </select>
							<CheckboxInput
								v-if="!filters.status"
								:value="filters.show_disabled_users"
								@input="value => refresh({ show_disabled_users: value })"
								:label="$t('show-disabled-users?')"
								class="ml-4 align-items-center"
							/>
						</div>

                    </div>
                </template>

                <template v-slot:options>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import CheckboxInput from "src/components/Inputs/CheckboxInput.vue";
import CSVGenerator from "src/modules/csvgenerator.js"

export default {
    components: {
        Table,
        CheckboxInput
    },
    data() {
        return {
            users: [],
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
                role: '',
                show_disabled_users: false,
                status: '',
                programme: '',
                year: ''
            },
            programme: null,
            status: null,
            total_count: 0,
            roles: [],
            loading: true,
            submitting: false,
            editUserId: 0,
            csvCols : ['id', 'firstname', 'lastname', 'email', 'username', 'email', 'jobtitle']
        }
    },
    async mounted() {
        this.allRoles()
        await this.listUsers()
        this.loading = false
    },
    methods: {
        async listUsers() {
            if (this.submitting) return
            this.submitting = true
            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/users/list`, {
                    method: 'POST',
                    data: this.filters,
                })

                if (res.status !== 'SUCCESS') return
                this.users = res.results;
                this.filters.page = res.pagination.page
                this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total

            }
            catch (err) {
                this.$log.error.call(this, err)
            }
            finally {
                this.submitting = false
            }
        },
        async allRoles() {
            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/all`, {
                    method: 'GET'
                })

                if (res.status !== 'SUCCESS') return;

                this.roles = res.roles;
            }
            catch (err) {
                this.$log.error.call(this, err)
            }
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.listUsers()
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.listUsers()
        },
        generateCSV() {

            let colNames = {};

            for (let col in this.csvCols){
                colNames[this.csvCols[col]] = this.$t(this.csvCols[col])
            }

            this.filters.fetch_all = true;


            this.listUsers().then(()=>{

                const csvHandler = new CSVGenerator(this.users, colNames, 'class_test');
                
                return csvHandler.getCSV().catch((err) => console.error(err));
            })

        },
    }
}
</script>
